module.exports = __webpack_public_path__ + "static/media/heartBeatsGIF.20ab0fc2.gif";